import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsRowModel } from "src/app/models/widgets/widgets-row.model";
import { WidgetsArrayModel } from "src/app/models/widgets/widgets-array.model";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";

@Injectable({
  providedIn: 'root'
})
export class CloneArrayService extends AbstractClone {

  constructor(private injector: Injector) {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
      // Retrieve from injector to avoid circular dependency
      const widgetsCloneService = this.injector.get(CloneService);

      let orgWidget = origWidget as WidgetsArrayModel;
      const newArray = new WidgetsArrayModel();
      newArray.parentId = parentId;
      const rowDest = destWidget as WidgetsColumnModel;
      rowDest.children.push(newArray);
      orgWidget.children.forEach(childWidget => {
        widgetsCloneService.cloneFromJS(childWidget, newArray, isDragNDrop, isInsideQuestion, newArray.id);
      });      
  }
}
